import $ from "jquery";

const switchTabAction = () => {
	const target = {
		btnTab: ".tab-huren",
		content: ".tab-content",
		contentTitle: ".tab-content-title",
		contentDesc: ".tab-content-description",
		beschrijving: ".tab-content.beschrijving",
		huren: ".huren",
		huurvoorwaarden: ".huurvoorwaarden",
	};
	const $btnTab = $(target.btnTab);
	const init = () => {
		$(document).ready(function () {
			if ($btnTab.length && $("body:not(.elementor-editor-active)").length) {
				$(".huur-page-title .elementor-heading-title").text(
					$(".wrapper-content-huur_title").text()
				);
				exec();
			}
		});
	};
	const exec = () => {
		$(document.body).on("click", target.btnTab, function () {
			const $this = $(this);

			const $activeSection = $this.parent().find(".active");
			const targetSection = $this.attr("data-title");
			const targetActiveSection = $activeSection.attr("data-title");
			let $thisParent = $this.parentsUntil(".sec-huur-single-product");
			$thisParent = $($thisParent[$thisParent.length - 1]);
			console.log({ $thisParent });

			$activeSection.toggleClass("active");
			$this.toggleClass("active");

			let $targetContent = null;
			let $activeContent = null;
			let $targetTitle = null;
			let $activeTitle = null;

			if (targetSection === "beschrijving") {
				$targetContent = $thisParent.find(target.beschrijving);
			} else {
				$targetTitle = $thisParent.find(
					target.contentTitle + "." + targetSection
				);
				$targetContent = $thisParent.find(
					target.contentDesc + "." + targetSection
				);
			}

			if (targetActiveSection === "beschrijving") {
				$activeContent = $thisParent.find(target.beschrijving);
			} else {
				$activeTitle = $thisParent.find(
					target.contentTitle + "." + targetActiveSection
				);
				$activeContent = $thisParent.find(
					target.contentDesc + "." + targetActiveSection
				);
			}

			entranceAnim(
				[$targetTitle, $targetContent],
				[$activeTitle, $activeContent]
			);
		});
	};
	init();

	const entranceAnim = (elIn, elOut) => {
		const delay = 0;

		setTimeout(() => {
			elIn.forEach((item) => {
				if (item !== null) item.show(delay);
			});
		}, delay);

		elOut.forEach((item) => {
			if (item !== null) item.hide(delay);
		});
	};
};

try {
	switchTabAction();
} catch (error) {
	throw Error(error);
}
